module.exports = __webpack_public_path__ + "assets/img/e07326a1868ea28f5b7985688d712134.svg";